import _ from 'ckLodash';
import elementUtils from 'utils/elementUtils';
import rangeUtils from 'utils/rangeUtils';
import selectionUtils from 'utils/selectionUtils';
import utils from 'utils/utils';

var EMPTY_BLOCK = 0,
    START_BLOCK = 1,
    MIDDLE_BLOCK = 2,
    END_BLOCK = 3,
    INTO_BLOCK = 4;

function getText(editor, cursorRange, parentBlock, blockPosition) {
    var cursorNode = cursorRange.startContainer;
    var range = new CKEDITOR.dom.range(editor.editable());
    range.selectNodeContents(parentBlock);
    if (blockPosition === START_BLOCK) {
        range.setEnd(cursorNode, cursorRange.startOffset);
    } else if (blockPosition === END_BLOCK) {
        range.setStart(cursorNode, cursorRange.startOffset);
    } else {
        throw new Error('block position must be one of START_BLOCK or END_BLOCK');
    }
    return rangeUtils.getText(range);
}

function calcPasteBlockPosition(editor, selectedRange, parentBlock) {
    var textBeforeCursor = getText(editor, selectedRange, parentBlock, START_BLOCK);

    if (utils.isWhiteSpace(textBeforeCursor)) {
        return START_BLOCK;
    }

    var textAfterCursor = getText(editor, selectedRange, parentBlock, END_BLOCK);
    if (utils.isWhiteSpace(textAfterCursor)) {
        return END_BLOCK;
    }
    return MIDDLE_BLOCK;
}

function getPastePosition(editor, cursorPosition, cursorParentBlock, pasteDataBlockCount) {
    if (pasteDataBlockCount === 0) {
        return INTO_BLOCK;
    }
    var text = cursorParentBlock.getText();
    if (!text || utils.isWhiteSpace(text)) {
        return EMPTY_BLOCK;
    }
    return calcPasteBlockPosition(editor, cursorPosition, cursorParentBlock);
}


function insertAfter(editor, cursorParentBlock, dataTransformer, afterNode) {
    var cursorBlock = afterNode || cursorParentBlock;
    var ckFragment = utils.getCKDocumentFragment(dataTransformer.getHtml());
    ckFragment.insertAfterNode(cursorBlock);

    var lastInsertedBlock = cursorBlock.$;
    for (var i = 0; i < dataTransformer.getBlockCount(); i++) {
        lastInsertedBlock = lastInsertedBlock.nextElementSibling;
    }
    lastInsertedBlock = new CKEDITOR.dom.element(lastInsertedBlock);

    var range = new CKEDITOR.dom.range(editor.editable());
    range.selectNodeContents(selectionUtils.findLastTextNode(editor, lastInsertedBlock));
    range.collapse();
    range.select();
}

function insertBefore(editor, cursorParentBlock, dataTransformer, beforeNode) {
    var cursorBlock = beforeNode || cursorParentBlock;
    var ckFragment = utils.getCKDocumentFragment(dataTransformer.getHtml());
    ckFragment.insertBefore(cursorBlock);

    var range = new CKEDITOR.dom.range(editor.editable());

    range.selectNodeContents(editor.editable());
    range.setEndBefore(cursorBlock);
    var refNode = rangeUtils.findLastNonEmptyTextNode(range);
    range.selectNodeContents(refNode);
    range.collapse(false);
    range.select();
}

function replace(editor, cursorParentBlock, dataTransformer, replaceNode) {
    var cursorBlock = replaceNode || cursorParentBlock;
    insertBefore(editor, cursorParentBlock, dataTransformer, replaceNode);
    cursorBlock.remove();
}

function isCursorInTextNodeDirectChildOfTextBlock(cursorContainer, parentBlock) {
    return cursorContainer.type === CKEDITOR.NODE_TEXT && cursorContainer.getParent().equals(parentBlock);
}

/**
 * Split overriden spans:
 *  Example 1:
 *  <p><span><span>tt{}rr</span></span></p>
 *  <p><span><span>tt</span></span>{}<span><span>rr</span></span></p>
 *
 *  Example 2:
 *  <p><span><span>{}ttrr</span></span></p>
 *  <p>{}<span><span>ttrr</span></span></p>
 *
 *  Example 3:
 *  <p><span><span>ttrr{}</span></span></p>
 *  <p><span><span>ttrr</span></span>{}</p>
 */
function splitOverrides(range, parentBlock, offset) {
    range.splitElement(parentBlock);
    var newBlock = parentBlock.getNext();
    if (elementUtils.isElementTextEmpty(parentBlock)) {
        parentBlock.remove();
        return rangeUtils.createRange(newBlock, newBlock, 0);
    }
    if (!elementUtils.isElementTextEmpty(newBlock)) {
        while (newBlock.getChildCount() > 0) {
            parentBlock.append(newBlock.getChild(0));
        }
    }
    newBlock.remove();
    return rangeUtils.createRange(parentBlock, parentBlock, offset);
}

function getIndexForInsertAfterSplit(range, parentBlock) {
    return _.find(range.startPath().elements, function (element) {
        return element.getParent().equals(parentBlock);
    }).getIndex() + 1;
}

/**
 * This function will split the span tags with styles and
 * set the cursor under the text block
 *
 * The cursor position will be clean and ready for insert
 */
function clearOverridesForInsert(range, parentBlock) {
    if (isCursorInTextNodeDirectChildOfTextBlock(range.startContainer, parentBlock) || range.startContainer.equals(parentBlock)) {
        return null;
    }
    var offset = getIndexForInsertAfterSplit(range, parentBlock);
    return splitOverrides(range, parentBlock, offset);
}


function insertHtml(editor, dataTransformer, cursorParentBlock, cursorPosition, isFromOutsideCK) {
    if (!isFromOutsideCK) {
        cursorPosition = clearOverridesForInsert(cursorPosition, cursorParentBlock) || cursorPosition;
    }
    editor.insertHtml(dataTransformer.getHtml(), 'text', cursorPosition);
}

function cleanInsertHtml_new(editor, dataTransformer, selectionIntention, isFromOutsideCK) {
    var cursorPosition = selectionIntention.getRange();
    var cursorParentBlock = utils.getBlockParent(cursorPosition.startPath());
    var currentListItem = (cursorPosition.startPath()).contains('li');

    switch (getPastePosition(editor, cursorPosition, cursorParentBlock, dataTransformer.getBlockCount())) {
        case INTO_BLOCK:
            insertHtml(editor, dataTransformer, cursorParentBlock, cursorPosition, isFromOutsideCK);
            break;
        case EMPTY_BLOCK:
            replace(editor, cursorParentBlock, dataTransformer, currentListItem);
            break;
        case START_BLOCK:
            insertBefore(editor, cursorParentBlock, dataTransformer, currentListItem);
            break;
        case MIDDLE_BLOCK:
            editor.insertHtml(dataTransformer.getHtml());
            break;
        case END_BLOCK:
            insertAfter(editor, cursorParentBlock, dataTransformer, currentListItem);
            break;
    }
}

function cleanInsertHtml() {
    cleanInsertHtml_new.apply(null, arguments);
}

export default {
    cleanInsertHtml: cleanInsertHtml
};
